import { Empty } from "components/Empty";
import FilterWithUnits from "components/FilterWithUnits";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";
import { mq, device } from "lib/media-query";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

const format = { unit: "km", divideBy: 1, decimals: 0 };

export const ActieradiusFilter = ({ condensed }) => {
    const filterOptions = useFilter("actieradius");
    const [value, , onChange] = useField("actieradius");

    const options = filterOptions.map((o) => ({ id: o }));

    return (
        <Grid condensed={condensed}>
            <FilterWithUnits
                filterId="filter-actieradius"
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                datalayerKey="actieradius"
                helpText="Minimaal"
                data={options}
                format={format}
            />
            <Empty />
        </Grid>
    );
};
